import { useId, type ReactNode } from "react";
import { Field } from "@/shared/rd";

/**
 * The kit's `Field` with a generated id, so the label is a real `<label for>`
 * of the control the render prop draws. A required field gets the asterisk.
 * An error gets its own id, which the render prop receives to link the
 * control (`aria-describedby`).
 */
export function WaField({
  label,
  help,
  error,
  required,
  children,
}: {
  label: ReactNode;
  help?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: (id: string, errorId: string | undefined) => ReactNode;
}) {
  const id = useId();
  const errorId = error ? `${id}-error` : undefined;
  return (
    <Field
      htmlFor={id}
      help={error ? undefined : help}
      label={
        required ? (
          <>
            {label}
            <span aria-hidden="true" style={{ color: "var(--rd-red)" }}>
              {" *"}
            </span>
          </>
        ) : (
          label
        )
      }
    >
      {children(id, errorId)}
      {error ? (
        <span id={errorId} className="rd-field-error" role="alert">
          {error}
        </span>
      ) : null}
    </Field>
  );
}
